
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const usePersistedRoute = () => {
  console.log("persistedRoute triggered...")
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Only redirect if not already on a target path that requires authentication
    const lastRoute = localStorage.getItem('lastRoute');
    console.log("last route:", lastRoute)
    if (lastRoute && location.pathname === '/' && lastRoute !== location.pathname) {
      console.log("navigating...")
      navigate(lastRoute);
    }
  }, [location, navigate]);

  useEffect(() => {
    // Persist only if it's a valid path for logged-in users
    if (['/', '/login', '/register'].indexOf(location.pathname) === -1) {
      console.log("setting last route to : " )
      localStorage.setItem('lastRoute', location.pathname + location.search);
      console.log("last route set: ", localStorage.lastRoute)
    }
  }, [location]);
}

export default usePersistedRoute;

// import { useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';

// const usePersistedRoute = () => {
//     const location = useLocation();
//     const navigate = useNavigate();

//     useEffect(() => {
//         const lastRoute = localStorage.getItem('lastRoute');
//         // Only navigate if the last stored route is different from the current and the path is not the root
//         if (lastRoute && lastRoute !== location.pathname && location.pathname === '/') {
//             navigate(lastRoute);
//         }
//     }, [navigate, location.pathname]);

//     useEffect(() => {
//         // Persist every path except the root, login, and register
//         if (!['/', '/login', '/register'].includes(location.pathname)) {
//             localStorage.setItem('lastRoute', location.pathname + location.search);
//         }
//     }, [location.pathname, location.search]);
// }

// export default usePersistedRoute;
